import { axiosInstance } from './api';

export interface ZoneRole {
  zone_id: number;
  role: string;
  org_id: number | null;
}

export interface OrgRole {
  org_id: number;
  role: string;
}

export interface GlobalRole {
  role: string;
}

export interface CurrentUser {
  id: number | string;
  username: string;
  email?: string | null;
  is_superuser?: boolean;
  is_staff?: boolean;
  /** Per-zone role records from ZoneMembership. May be absent on older backends. */
  zone_roles?: ZoneRole[];
  /** Per-org role records from OrgMembership. May be absent on older backends. */
  org_roles?: OrgRole[];
  /** Cross-zone role records from GlobalMembership (e.g. linza_support).
   *  May be absent on older backends. */
  global_roles?: GlobalRole[];
  /** Server-side language preference. 'ru' | 'en'. Absent on older backends → fall back to localStorage. */
  lang?: string;
  /** If true, UI should hide the language picker for this user. */
  disable_language_picker?: boolean;
  /** Telegram identity bound to this Django user, if any.
   *  `confirmed=false` means the operator pre-bound a username but the
   *  user hasn't actually signed in via TG yet (telegram_id is still
   *  NULL on the BE row). */
  telegram_binding?: {
    telegram_id: number | null;
    telegram_username: string;
    confirmed: boolean;
  } | null;
}

export const ME_SWR_KEY = '/core/api/auth/users/me/';

export const fetchCurrentUser = async (): Promise<CurrentUser> => {
  const resp = await axiosInstance.get<CurrentUser>(ME_SWR_KEY);
  return resp.data;
};

export const patchCurrentUser = (data: Partial<Pick<CurrentUser, 'lang' | 'disable_language_picker'>>) =>
  axiosInstance.patch(ME_SWR_KEY, data);

export interface SetPasswordPayload {
  current_password: string;
  new_password: string;
}

export const setPassword = (payload: SetPasswordPayload) =>
  axiosInstance.post('/core/api/auth/users/set_password/', payload);
